module.exports = __webpack_public_path__ + "static/media/facebook_icon.9d6fc4c6.svg";